"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _tabChangeEvents;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductInstallmentsCrossStep = void 0;

var _tabs = require("@creditas-lab/tabs");

var _services = require("../../services");

var _hooks = require("../../hooks");

var _constants = require("../../constants");

var _mocks = require("../../mocks");

var getTabByProductsRanges = function getTabByProductsRanges(intendedCredit) {
  var _Object$entries$find;

  var _ref = (_Object$entries$find = Object.entries(_mocks.CreditRangeByProduct).find(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        _ref4$ = _ref4[1],
        min = _ref4$.min,
        max = _ref4$.max;

    return intendedCredit >= min && intendedCredit <= max;
  })) != null ? _Object$entries$find : [],
      _ref2 = _slicedToArray(_ref, 1),
      productName = _ref2[0];

  return productName != null ? productName : _constants.ProductTypes.HOME;
};

var tabChangeEvents = (_tabChangeEvents = {}, _defineProperty(_tabChangeEvents, _constants.TabsPosition[_constants.ProductTypes.HOME], _services.dispatchHomeTabChangeEvent), _defineProperty(_tabChangeEvents, _constants.TabsPosition[_constants.ProductTypes.AUTO], _services.dispatchAutoTabChangeEvent), _tabChangeEvents);

var useProductInstallmentsCrossStep = function useProductInstallmentsCrossStep() {
  var _ref5 = (0, _hooks.useSimulator)(),
      intendedCredit = _ref5.intendedCredit;

  var tabByProductRange = getTabByProductsRanges(intendedCredit);
  var tabs = (0, _tabs.useTabState)(_constants.TabsPosition[tabByProductRange]);

  var onTabChange = function onTabChange(currentTabIndex) {
    var tabChangeEvent = tabChangeEvents[currentTabIndex];
    tabChangeEvent();
  };

  return {
    tabs: tabs,
    onTabChange: onTabChange
  };
};

exports.useProductInstallmentsCrossStep = useProductInstallmentsCrossStep;